var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 22C17.5231 22 22.0002 17.5228 22.0002 12C22.0002 6.47715 17.5231 2 12.0002 2C6.4774 2 2.00024 6.47715 2.00024 12C2.00024 17.5228 6.4774 22 12.0002 22Z",
    fill: "#25CE7D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8097 8.90498C16.1148 9.00307 16.2925 9.3136 16.2317 9.62058L16.2134 9.69126L15.6322 11.4998L16.8238 11.5C17.1689 11.5 17.4488 11.7798 17.4488 12.125C17.4488 12.4455 17.2075 12.7097 16.8967 12.7458L16.8238 12.75H15.6184C15.4874 12.75 15.3658 12.7097 15.2653 12.6408L14.4054 15.3163C14.2276 15.8692 13.4716 15.8935 13.2433 15.3888L13.2155 15.3167L11.9992 11.5419L10.7894 15.3159C10.612 15.8694 9.85523 15.8937 9.62702 15.3884L9.59928 15.3163L8.73918 12.6409C8.65767 12.6968 8.56223 12.7338 8.45915 12.7458L8.38627 12.75H7.18091C6.83573 12.75 6.55591 12.4702 6.55591 12.125C6.55591 11.8045 6.79718 11.5403 7.10802 11.5042L7.18091 11.5L8.37216 11.4998L7.79125 9.69126C7.68562 9.36264 7.86639 9.01061 8.19501 8.90498C8.50016 8.8069 8.82549 8.95576 8.95498 9.24064L8.98128 9.30874L10.1936 13.0794L11.403 9.30915C11.5804 8.75585 12.3368 8.73128 12.5652 9.23621L12.593 9.30834L13.8092 13.0838L15.0234 9.30874C15.129 8.98013 15.481 8.79936 15.8097 8.90498Z",
    fill: "#B9FFB8",
    stroke: "#B9FFB8",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.b2d88ce896b0f2357be8c7cd8e3f3743.svg";
export { ForwardRef as ReactComponent };